import { Document } from '@/db/types/document';
import { createLogger, LogLevel } from '@/lib/logger';

const logger = createLogger('routes', LogLevel.WARN);

export function documentPath(clientLabel: string, doc: Pick<Document, 'id' | 'local_id'>) {
  const isDraft = typeof doc.id === 'string' && typeof doc.local_id === 'string' && doc.local_id.startsWith('draft-');
  const docId = isDraft ? `drafts/${doc.local_id}` : doc.id;
  if (docId == null) {
    logger.warn('documentPath called with no id or local_id', doc);
    return null;
  }
  return `/clients/${clientLabel}/documents/${docId}/edit`;
}
